import { isMockMode, post, simulateDelay } from "../api";

export const updateOrgAvatar = (data) => {
	if (isMockMode()) {
		const testData = {
			success: true,
		};

		return simulateDelay(50, () => testData);
	}

	return post(`Orgs/UpdateAvatar`, data);
};
